import {InitPage} from "../index";
import swal from "sweetalert";
import * as Toastr from "toastr";


class ElcTempAgencyCheckin {
    constructor() {
         $("#date_time").datepicker({
             dateFormat: "mm/dd/yy",
             onSelect: function(d,i){
               let path = $('#date_time').attr('data-path');
               if(d !== i.lastVal){
                 window.location.href =  path + "?datetime=" + d.replace(/\//g,"%2F") ;

               }
             }
         })

        $("#date_btn").on("click", function(e) {
            e.preventDefault();
            $("#date_time").click();
        });

        $("#date_btn").on("click", function(e) {
            e.preventDefault();
            $("#date_time").datepicker("show");
        });

        $(".items-list").select2({
            placeholder: "",
            allowClear: true
        });

        $("#elc_temp_agency_assign_employee_id").on("select2:select", function (e) {
          let tempAgencyId = $("#elc_temp_agency_assign_employee_id :selected").attr("data-tempagency_id");
          $("#elc_temp_agency_assign_temp_agency_id").val(tempAgencyId);
        });

        $(".checkin-btn").on("click", function(e){
          $.ajax({
            type: "PUT",
            url:  $(this).data('data-path')
        }).then(response => {
            if (response.status != 'OK') {
                Toastr.error(response.status,"Error");
            }
            else {
                window.location.reload();
            }
        })
        });

        $("#temp_agency_id").on("change", function(){
            let path = $(this).attr('data-path');
            let datatime = $(this).attr('data-date');
            let tempagency = $('#temp_agency_id :selected').val();
            let query = $("#query").val();
            window.location.href =  path + "?datetime=" + datatime + "&temp_agency=" + tempagency + "&query=" + query ;
        });

        $('.emp-print').on('click', function(e){
          e.preventDefault();
          // Prevent people from being trigger happy
          let _this = this;
          $.post(`${$(this).data('path')}?printer_id=${$('#selectedPrinter').val()}`, function(data) {
              $('#cell_' + data.row_id).html(data.update_date + "<br>" + data.update_time);
              Toastr.success("Print Scheduled");
          });
        });
    }

}

export function LoadPage() {
    InitPage("temp_agency_checkins index", () => {
        const elc_temp_agency_checkin = new ElcTempAgencyCheckin();
    });
}
